import React from 'react'
import SelectHub from '../components/SelectHub/SelectHub'

function SelectHubPage() {
    return (
        <SelectHub />
    )
}

export default SelectHubPage